import React from 'react'
import AccessTokenTable from './AccessTokenTable'
import UserCreationForm from './UserCreationForm'
import UserRemovalTable from './UserRemovalTable'
import PageAccessTokenTable from './PageAccessTokenTable'
import '../styles/components.css'

const AdminUserManagement = () => {
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div className="fc-card">
          <div className="fc-card-title" style={{ marginBottom: 16 }}>User creation</div>
          <UserCreationForm />
        </div>
        <div className="fc-card">
          <div className="fc-card-title" style={{ marginBottom: 16 }}>User removal</div>
          <UserRemovalTable />
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div className="fc-card">
          <div className="fc-card-title" style={{ marginBottom: 16 }}>User access tokens</div>
          <AccessTokenTable />
        </div>
        <div className="fc-card">
          <div className="fc-card-title" style={{ marginBottom: 16 }}>Facebook page access tokens</div>
          <PageAccessTokenTable />
        </div>
      </div>
    </>
  )
}

export default AdminUserManagement
